import React, { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { CustomeStyle } from "../Css/CustomeStyle";
import WebsiteFooter from "../../websitecomponents/Fotter";
import Header from "./header";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { FiShoppingCart } from "react-icons/fi";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../redux/slices/AllProductSlice";
import { AddToCart } from "../redux/slices/AddTocartSlice";
import { toast } from "react-toastify";
import { AddWishlist } from "../redux/slices/AddWishlistSlice";
import { GetBanner } from "../redux/slices/GetBannerSlice";
import GetcategorySubcategory from "./getcategorysubcategory";
import HeaderBrand from "./headerBrand";
import { GetCategory } from "../redux/slices/GetCategorySlice";
import axios from "axios";
import endPoint from "../redux/EndPoint/endpoint";

const Home = () => {
  const dispatch = useDispatch();
  const [likedProducts, setLikedProducts] = useState(new Set());
  const { AllData } = useSelector((state) => state.product);
  const [isVisible, setIsVisible] = useState(false);
  const { AllCategory } = useSelector((state) => state.category);
  const [categoryDataMap, setCategoryDataMap] = useState({});
  const [isLoading, setIsLoding] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [trendingProducts, setTrendingProducts] = useState([]);
  const [topProducts, setTopProducts] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function getRandomCategories(allCategories, count = 8) {
    const shuffled = [...allCategories].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  }

  useEffect(() => {
    const loadInitialData = async () => {
      if (!AllCategory?.length || hasFetched) return;
      setIsLoding(true);
      const selected = getRandomCategories(AllCategory);
      const names = selected.map((cat) => cat.name);
      const newCategoryDataMap = {};

      for (const name of names) {
        try {
          const res = await axios.get(
            `${endPoint.GETCATEGORYDATA}?query=${name}`,
          );
          if (res?.data?.data?.length > 0) {
            newCategoryDataMap[name] = res.data;
          }
        } catch (error) {
          console.log(`Category error: ${name}`, error.message);
        }
      }

      try {
        const trendingRes = await axios.get(endPoint.GetTrandingProduct);
        const topRes = await axios.get(endPoint.GetTopSaleProduct);
        setTrendingProducts(trendingRes?.data?.trendingProducts || []);
        setTopProducts(topRes?.data || []);
      } catch (error) {
        console.log("Trending or TopSale error", error.message);
      }

      setCategoryDataMap(newCategoryDataMap);
      setIsLoding(false);
      setHasFetched(true);
    };

    loadInitialData();
  }, [AllCategory, hasFetched]);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    dispatch(fetchProducts());
    dispatch(GetBanner());
    dispatch(GetCategory());
  }, []);

  const toggleLike = (productId) => {
    dispatch(AddWishlist(productId));
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const handleAddToCart = (item) => {
    const cartData = {
      productId: item?._id,
      quantity: 1,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      } else {
        console.log("Responce Error");
      }
    });
  };

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);
    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-16647750621');
      `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]',
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow">
        {AllCategory && AllCategory.length > 0 && (
          <>
            <Header />
            <HeaderBrand />
          </>
        )}
        {isLoading ? (
          <div className="flex justify-center items-center m-5">
            <div className="text-lg font-semibold animate-pulse">
              Loading...
            </div>
          </div>
        ) : (
          <div className={"w-[90%] items-center mx-auto bg-white p-1 mb-10"}>
            <div className="px-4 py-10">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {trendingProducts?.length > 0 && (
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <h2 className="text-xl font-bold mb-4 text-gray-800 text-center">
                      Trending Products
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4">
                      {trendingProducts.slice(0, 4).map((product) => (
                        <Link
                          key={product._id}
                          to={`/category/${product?.category ? generateSlug(product?.category) : "-"}/${generateSlug(product?.title)}/${generateSlug(product?._id)}`}
                          state={{ product }}
                          className="p-3 no-underline rounded-xl border hover:shadow-md transition flex flex-col"
                        >
                          <img
                            src={product.images?.[0]}
                            alt={product.title}
                            className="w-full h-40 object-contain rounded mb-2"
                          />
                          <h3 className="text-black text-sm md:text-base line-clamp-1 font-bold leading-none mb-1">
                            {product.title}
                          </h3>
                          <p className={CustomeStyle.description}>
                            {product.description}
                          </p>
                          <div className="mt-2 flex items-center justify-between text-sm">
                            <div className="flex-row">
                              <span className="text-red-600 font-bold">
                                ₹{product.salePrice}
                              </span>
                              <span className="text-green-600 text-xs mt-1  ms-2">
                                {product.discount}% off
                              </span>
                            </div>
                            <span className="line-through text-gray-400 text-xs">
                              ₹{product.regularPrice}
                            </span>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                )}

                {topProducts?.length > 0 && (
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <h2 className="text-xl font-bold mb-4 text-gray-800 text-center">
                      Top Selling Products
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4">
                      {topProducts?.slice(0, 4).map((product) => (
                        <Link
                          key={product._id}
                          to={`/category/${product?.category ? generateSlug(product?.category) : "-"}/${generateSlug(product?.title)}/${generateSlug(product?._id)}`}
                          state={{ product }}
                          className="p-3 rounded-xl border hover:shadow-md transition flex flex-col no-underline"
                        >
                          <img
                            src={product.images?.[0]}
                            alt={product.title}
                            className="w-full h-40 object-contain rounded mb-2"
                          />
                          <h3 className="text-black text-sm md:text-base line-clamp-1 font-bold leading-none mb-1">
                            {product.title}
                          </h3>
                          <p className={CustomeStyle.description}>
                            {product.description}
                          </p>
                          <div className="mt-2 flex items-center justify-between text-sm">
                            <span className="text-red-600 font-bold">
                              ₹{product.salePrice}
                            </span>
                            <span className="line-through text-gray-400 text-xs">
                              ₹{product.regularPrice}
                            </span>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {Object.entries(categoryDataMap).map(
              ([categoryName, categoryData]) => (
                <div key={categoryName} className="my-8">
                  <h2 className="text-xl md:text-2xl font-bold mb-4">
                    {categoryName}
                  </h2>

                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 sm:gap-4">
                    {categoryData?.data?.slice(0, 10).map((item, index) => (
                      <div
                        key={item?._id}
                        className="overflow-hidden relative border border-gray-200 sm:px-5 sm:py-3 px-3 py-2 hover:scale-105 hover:-translate-y-1"
                      >
                        <img
                          src={item?.images[0]}
                          alt={item.name}
                          className="w-full h-20 sm:h-40 object-contain  rounded-x"
                        />
                        <button
                          className="like-btn absolute top-2 left-2"
                          onClick={() => toggleLike(item._id)}
                        >
                          {likedProducts.has(item._id) ? (
                            <FaHeart
                              size="24px"
                              className="text-red-500 sm:text-lg text-xs"
                            />
                          ) : (
                            <FaRegHeart
                              size="24px"
                              className="text-gray-400 sm:text-lg md:text-xs"
                            />
                          )}
                        </button>
                        <button
                          onClick={() => handleAddToCart(item)}
                          className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50"
                        >
                          <FiShoppingCart className="text-black sm:text-base md:text-xl lg:text-2xl" />
                        </button>
                        <Link
                          to={`/category/${
                            item?.category ? generateSlug(item?.category) : "-"
                          }/${generateSlug(item?.title)}/${generateSlug(item?._id)}`}
                          state={{ item }}
                          className="block  no-underline"
                        >
                          <div className="mb-1 end-2 lg:mt-3">
                            <h2 className="text-black text-sm md:text-base line-clamp-1 font-bold leading-none mb-1">
                              {item.title}
                            </h2>

                            <div className="">
                              <span className={CustomeStyle.description}>
                                {item.description}
                              </span>
                            </div>
                            <div className="flex items-center justify-center gap-1">
                              <span className={CustomeStyle.text}>
                                ₹{item?.salePrice}
                              </span>
                              <span
                                className={`${CustomeStyle.text} line-through`}
                              >
                                ₹{item?.regularPrice}
                              </span>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              ),
            )}

            {AllData?.data?.length > 0 && (
              <>
                <div className="flex justify-between flex-row items-center">
                  <h1 className={CustomeStyle.headerText}>New Arrival</h1>
                  <Link
                    to="/AllProductData"
                    className="text-red-500 hover:text-red-700 flex items-center space-x-2  no-underline"
                  >
                    <span className="text-black font-bold">View All</span>
                    <FiArrowRight color="#000" size={18} />
                  </Link>
                </div>
                <div className="w-[100%] sm:w-[95%] md:w-[100%]">
                  <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2  sm:gap-1 lg:gap-3 mt-2 ">
                    {AllData?.data?.length > 0 ? (
                      AllData?.data?.slice(0, 30).map((item) => (
                        <div
                          key={item._id}
                          className="bg-white shadow rounded-md overflow-hidden relative border border-gray-200 sm:px-5 sm:py-3 px-3 py-2 hover:scale-105 hover:-translate-y-1"
                        >
                          <img
                            src={item?.images[0]}
                            alt={item.name}
                            className="w-full h-20 sm:h-40 object-contain bg-light rounded-x"
                          />
                          <button
                            className="like-btn absolute top-2 left-2"
                            onClick={() => toggleLike(item._id)}
                          >
                            {likedProducts.has(item._id) ? (
                              <FaHeart
                                size="24px"
                                className="text-red-500 sm:text-lg text-xs"
                              />
                            ) : (
                              <FaRegHeart
                                size="24px"
                                className="text-gray-400 sm:text-lg md:text-xs"
                              />
                            )}
                          </button>
                          <button
                            onClick={() => handleAddToCart(item)}
                            className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50"
                          >
                            <FiShoppingCart className="text-black sm:text-base md:text-xl lg:text-2xl" />
                          </button>
                          <Link
                            to={`/category/${
                              item?.category
                                ? generateSlug(item?.category)
                                : "-"
                            }/${generateSlug(item?.title)}/${generateSlug(item?._id)}`}
                            state={{ item }}
                            className="block  no-underline"
                          >
                            <div className="mb-1 end-2 lg:mt-3">
                              <h2 className="sm:text-xl text-xs text-black from-neutral-600 sm:mt-0 mt-3">
                                {item.name}
                              </h2>
                              <h2 className="text-black text-sm md:text-base line-clamp-1 font-bold leading-none mb-1">
                                {item.title}
                              </h2>
                              <div className="">
                                <span className={CustomeStyle.description}>
                                  {item.description}
                                </span>
                              </div>
                              <div className="flex items-center justify-center gap-1">
                                <span className={CustomeStyle.text}>
                                  ₹{item?.salePrice}
                                </span>
                                <span
                                  className={`${CustomeStyle.text} line-through`}
                                >
                                  ₹{item?.regularPrice}
                                </span>
                              </div>
                            </div>
                          </Link>
                        </div>
                      ))
                    ) : (
                      <div className="text-center text-lg font-semibold">
                        No Product Found
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            {AllCategory && AllCategory?.length > 0 && (
              <GetcategorySubcategory />
            )}
          </div>
        )}
        <button
          onClick={scrollToTop}
          className={`fixed bottom-5 right-5 border bg-gray-200 text-black font-semibold px-2 py-2 rounded-full shadow-lg transition-all duration-300 ${
            isVisible ? "opacity-100 scale-100" : "opacity-0 scale-0"
          }`}
        >
          ⬆ Top
        </button>
      </div>
      <WebsiteFooter />
    </div>
  );
};

export default Home;
